import React from 'react';

function Leave() {
  return (
    <section className="page-content">
      <div className="container">
        <h1 className="page-title">ForTuber Account Deletion Guide</h1>
        <div className="page-body">
          <p>To delete your <strong className="important">ForTuber</strong> account, you can do so immediately through <strong className="important">Settings - Account Deletion</strong>.</p>

          <p>Once the deletion is completed, your personal information will be <strong className="important">deleted</strong> within minutes.</p>

          <p>If you no longer wish to use the app or want to delete your account for privacy reasons, please proceed using the method above.</p>

          <p>If you have any additional questions or encounter difficulties during the deletion process, please contact us at:</p>

          <div className="contact-box">
            <p><strong className="important">Email:</strong> cddchingudeul@gmail.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Leave;
